import { useState } from "react";
import _ from "lodash";

import LoadingComponent from "../Commons/LoadingComponent";
import AlertModal from "../Commons/AlertModal";
import ConfirmModal from "../Commons/ConfirmModal";


import { MdKeyboardDoubleArrowRight, MdOutlineExpandLess, MdOutlineExpandMore } from "react-icons/md";
import { getLabel } from "../../tools/Dictionary";

const ConditionDesignerSort = (props) =>
{

  //Props
  const OnCloseModal = props.OnCloseModal;
  const OnConfirm = props.OnConfirm;
  const Step = props.Step;
  const CurrentStep = props.CurrentStep;
  


  //State
  const [condition, setCondition] = useState(CurrentStep.condition.map(c => {

    let linkedStep = Step.find(s => s._id == c.processStep);

    c.processStepTitle = linkedStep.title;

    return c;
  }));;
  const [loading] = useState(false);
  const [alert] = useState({
    Title: "",
    Message: "",
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });
  const [confirm] = useState({
    Title: "",
    Message: "",
    Cancel: "",
    onCancel: () => void 0,
    Confirm: "",
    onConfirm: () => void 0,
    Display: false
  });


  const onClickMove = (_index, _move) => {

    if (_move == -1 && _index == 0) return;


    if (_move == 1 && _index == condition.length - 1) return;

    
    let toUpdateCondition = _.cloneDeep(condition);

    const [element] = toUpdateCondition.splice(_index, 1);
    toUpdateCondition.splice(_index + _move, 0, element);


    setCondition(toUpdateCondition);
  };

  const onClickConfirm = () => {

    let toUpdateStep = _.cloneDeep(CurrentStep);
    let toUpdateCondition = _.cloneDeep(condition);

    toUpdateStep.condition = toUpdateCondition.map((c, index) => {
      c.order = (index + 1) * 10;
      delete c.processStepTitle;
      return c;
    });

    OnConfirm(toUpdateStep);
    OnCloseModal();
  };


  return (
    <div className="page_modal_background">
      <div className="page_modal_cont" style={{ width: "700px" }}>
        <LoadingComponent
          display={loading}
          label={getLabel("App", "Loading")}
        />
        <AlertModal
          Title={alert.Title}
          Message={alert.Message}
          Confirm={alert.Confirm}
          onConfirm={alert.onConfirm}
          Display={alert.Display}
        />
        <ConfirmModal
          Display={confirm.Display}
          Title={confirm.Title}
          Message={confirm.Message}
          Cancel={confirm.Cancel}
          onCancel={confirm.onCancel}
          Confirm={confirm.Confirm}
          onConfirm={confirm.onConfirm}
        />
        <div className="page_modal_header_cont" style={{ marginBottom: "10px" }}>
          {getLabel("ConditionDesigner", "Sort your conditions")}
        </div>
        <div className="page_modal_body_cont">
          <div className="conditiondesigner_sort_cont page_noselect">
            {condition.map((c, index) => (
                <div className="conditiondesigner_sort_item" key={c._id}>
                  <div className="conditiondesigner_sort_item_icon">
                    <MdKeyboardDoubleArrowRight />
                  </div>
                  <div className="conditiondesigner_sort_item_data">
                    {c.processStepTitle}
                  </div>
                  <div className="conditiondesginer_cond_item_action" >
                    <div className="conditiondesginer_cond_item_action_button conditiondesginer_cond_item_action_button_up" onClick={() => onClickMove(index, -1)}>
                      <MdOutlineExpandLess />
                    </div>
                    <div className="conditiondesginer_cond_item_action_button conditiondesginer_cond_item_action_button_bottom" onClick={() => onClickMove(index, 1)}>
                      <MdOutlineExpandMore />
                    </div>
                  </div>
                </div>
            ))}
          </div>
        </div>
        <div className="page_modal_footer_cont">
          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Close")}
            style={{ backgroundColor: "grey", maxWidth: "200px" }}
            onClick={(loading && !OnCloseModal) ? undefined : OnCloseModal}
            disabled={loading}
          />

          <input
            type="button"
            className="page_button page_modal_footer_button"
            value={getLabel("App", "Confirm")}
            style={{ maxWidth: "200px" }}
            onClick={onClickConfirm}
            disabled={loading}
          />
        </div>
      </div>
    </div>
  );

};

export default ConditionDesignerSort